exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  min-height: inherit;\n  position: relative;\n  overflow-x: hidden;\n}\nhtml {\n  font-family: \"Open Sans\", Arial, Helvetica, sans-serif;\n}\nbody {\n  margin: 0;\n  min-height: 100vh;\n  background-color: #cd718e;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-weight: 400;\n  -webkit-text-size-adjust: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-appearance: none;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n}\nimg {\n  max-width: 100%;\n  height: auto;\n}\nul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\na {\n  color: #ffffff;\n  text-decoration: none;\n}\nli {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\nblockquote {\n  margin: 0;\n}\np {\n  margin: 0;\n}\npicture {\n  display: block;\n}\n*:focus {\n  outline: thin dotted;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0201a292","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 27
// module chunks = 0